<template>
  <BlocksFinder :role="role" :packageFilter="packageFilter">
    <li
      class="py-2 border !border-b rounded-b-lg border-dashed font-semibold duration-150 cursor-pointer hover:brightness-105 flex justify-center items-center space-x-2"
      :class="!empty ? '!border-gray-300 bg-gray-50 text-gray-700' : '!border-blue-600 bg-blue-50 text-blue-600 !rounded-lg !py-3'"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5" />
      </svg>
      <span class="-translate-y-[1px]">Select blocks</span>
    </li>
  </BlocksFinder>
</template>

<script>

import BlocksFinder from "../../BlocksFinder/BlocksFinder"

export default {
  components: {
    BlocksFinder,
  },
  props: ['role', 'empty', 'packageFilter'],
}

</script>
